export default __webpack_public_path__ + "static/media/114.c0f0d1f4.jpg";